import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PlanningService {
    constructor(http) {
        this.http = http;
    }
    paginateDeadlines(projectId, page = 1) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/deadlines?page=${page}`);
    }
    getCoverURLImageByAppliedTemplate(projectId) {
        return this.http.get(`${environment.base_url}/templates/text_structures/covers/urlImage/${projectId}`);
    }
    paginateDataExtractions(projectId, page = 1) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/data_extractions?page=${page}`);
    }
    getExtractionQuestions(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/data_extractions/questions`);
    }
    // in_checklist serve para dizer se é para tratar ou não o resultado pelo campo in_checklist
    getProtocol(projectId, in_checklist = false) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/protocols?in_checklist=${in_checklist}`);
    }
    getQualityEvaluations(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/quality_evaluations`);
    }
    storeProtocolMethodology(methodology) {
        return this.http.put(`${environment.base_url}/projects/planning/protocols/save_methodology`, methodology);
    }
    storeDeadline(deadline) {
        return this.http.post(`${environment.base_url}/projects/planning/deadlines`, deadline);
    }
    updateDeadline(id, form) {
        return this.http.put(`${environment.base_url}/projects/planning/deadlines/${id}`, form);
    }
    storeProtocolResearchQuestion(researchQuestion) {
        return this.http.post(`${environment.base_url}/projects/planning/protocols/questions`, researchQuestion);
    }
    storeQualityEvaluationQuestion(question) {
        return this.http.post(`${environment.base_url}/projects/planning/quality_evaluations/questions`, question);
    }
    storeQualityEvaluationAnswer(answer) {
        return this.http.post(`${environment.base_url}/projects/planning/quality_evaluations/answers`, answer);
    }
    bulkQualityEvaluationAnswer(quality_evaluation_id, answers) {
        return this.http.put(`${environment.base_url}/projects/planning/quality_evaluations/answers/bulk/${quality_evaluation_id}`, answers);
    }
    storeProtocolSelectionCriteria(selectionCriteria) {
        return this.http.put(`${environment.base_url}/projects/planning/protocols/save_selection_criteria`, selectionCriteria);
    }
    storeProtocolHypothese(hypothese) {
        return this.http.post(`${environment.base_url}/projects/planning/protocols/hypotheses`, hypothese);
    }
    storeExtrationQuestion(question) {
        return this.http.post(`${environment.base_url}/projects/planning/extraction_questions`, question);
    }
    updateExtrationQuestion(id, form) {
        return this.http.put(`${environment.base_url}/projects/planning/extraction_questions/${id}`, form);
    }
    updateProtocol(protocol_id, data) {
        return this.http.patch(`${environment.base_url}/projects/planning/protocols/${protocol_id}/update`, data);
    }
    updateProtocolObjectives(protocol_id, data) {
        return this.http.patch(`${environment.base_url}/projects/planning/protocols/${protocol_id}/update_objectives`, data);
    }
    updateQualityEvaluation(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/quality_evaluations/${id}`, form);
    }
    updateQualityEvaluationQuestion(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/quality_evaluations/questions/${id}`, form);
    }
    deleteQualityEvaluationQuestion(id) {
        return this.http.delete(`${environment.base_url}/projects/planning/quality_evaluations/questions/${id}`);
    }
    updateQualityEvaluationAnswer(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/quality_evaluations/answers/${id}`, form);
    }
    deleteQualityEvaluationAnswer(id) {
        return this.http.delete(`${environment.base_url}/projects/planning/quality_evaluations/answers/${id}`);
    }
    updateProtocolResearchQuestion(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/protocols/questions/${id}`, form);
    }
    deleteProtocolResearchQuestion(id) {
        return this.http.delete(`${environment.base_url}/projects/planning/protocols/questions/${id}`);
    }
    updateProtocolHypothesis(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/protocols/hypotheses/${id}`, form);
    }
    deleteProtocolHypothesis(id) {
        return this.http.delete(`${environment.base_url}/projects/planning/protocols/hypotheses/${id}`);
    }
    storeProtocolKeyword(keyword) {
        return this.http.post(`${environment.base_url}/projects/planning/protocols/keywords`, keyword);
    }
    updateProtocolKeyword(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/protocols/keywords/${id}`, form);
    }
    deleteProtocolKeyword(id) {
        return this.http.delete(`${environment.base_url}/projects/planning/protocols/keywords/${id}`);
    }
    bulkImportedPICO(protocol_id, keywords) {
        return this.http.put(`${environment.base_url}/projects/planning/protocols/keywords/bulk/${protocol_id}`, keywords);
    }
    storeProtocolSource(source) {
        return this.http.post(`${environment.base_url}/projects/planning/protocols/sources`, source);
    }
    updateProtocolSource(id, form) {
        return this.http.patch(`${environment.base_url}/projects/planning/protocols/sources/${id}`, form);
    }
    deleteProtocolSource(id) {
        return this.http.delete(`${environment.base_url}/projects/planning/protocols/sources/${id}`);
    }
    getProtocolSelectionCriterias(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/protocols/selection_criteria`);
    }
    storeDataExtraction(formData) {
        return this.http.post(`${environment.base_url}/projects/planning/extraction_questions/add`, formData);
    }
    allDeadlines(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/planning/all_deadlines`);
    }
    uploadDeadlineTableImage(projectName, base64) {
        return this.http.post(`${environment.base_url}/projects/planning/deadlines/upload_deadline_table_image`, {
            image_name_suffix: projectName,
            image_base64: base64
        });
    }
    getDeadlineTableImage(projectName) {
        return this.http.get(`${environment.base_url}/projects/planning/deadlines/${projectName}/get_deadline_table_image`);
    }
    deleteDeadlineTableImage(projectName) {
        return this.http.delete(`${environment.base_url}/projects/planning/deadlines/${projectName}/delete_deadline_table_image`);
    }
    saveOrdering(extractionQuestionsOrdered) {
        return this.http.post(`${environment.base_url}/projects/planning/extraction_questions/save_ordering`, {
            extraction_questions_ordered: extractionQuestionsOrdered
        });
    }
}
PlanningService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlanningService_Factory() { return new PlanningService(i0.ɵɵinject(i1.HttpClient)); }, token: PlanningService, providedIn: "root" });
